import { Link } from "react-router"

export function Logo({
  compact = false,
  variant,
  className,
}: {
  compact?: boolean
  variant?: "light" | "dark"
  className?: string
}) {
  const size = className ?? (compact ? "h-12 w-auto" : "h-16 sm:h-20 w-auto")

  // If a specific variant is forced, show only that logo
  if (variant === "dark") {
    return (
      <Link to="/" className="inline-flex shrink-0 items-center gap-3" aria-label="Smart Drain home">
        <img src="/media/smart-drain-logo-dark.png" alt="Smart Drain by Urban Inventors" className={size} />
      </Link>
    )
  }
  if (variant === "light") {
    return (
      <Link to="/" className="inline-flex shrink-0 items-center gap-3" aria-label="Smart Drain home">
        <img src="/media/smart-drain-logo.png" alt="Smart Drain by Urban Inventors" className={size} />
      </Link>
    )
  }

  // Default: auto-switch based on light/dark mode
  return (
    <Link to="/" className="inline-flex shrink-0 items-center gap-3" aria-label="Smart Drain home">
      <img src="/media/smart-drain-logo.png" alt="Smart Drain by Urban Inventors" className={`${size} block dark:hidden`} />
      <img src="/media/smart-drain-logo-dark.png" alt="Smart Drain by Urban Inventors" className={`${size} hidden dark:block`} />
    </Link>
  )
}
